@if (!isOperationConsultantHabilited(operation)) {
  <div
    class="flex-horizontal flex-center"
    [ouiTooltip]="habilitationToolTipText(operation.produitPreset ?? null)"
    [ouiTooltipPosition]="'top'"
    >
    <oui-icon iconPrefix class="color-error">gpp_bad</oui-icon>
    <div class="color-error">{{ displayName }}</div>
  </div>
}
@if (isOperationConsultantHabilited(operation)) {
  {{ displayName }}
}
